import { dateFilterTypes } from "../../utils";

export const filterInitialValues = {
    filter: [
        {
            number: '',
            a_filter_type: '',
            placeholder: 'Enter Number',
            type: 'number',
            shouldFilterOptionDisabled: false,
            label: 'Number',
        },
        {
            date: {
                from: '',
                to: '',
            },
            a_filter_type: '',
            placeholder: 'Custom Date Range...',
            type: 'date',
            shouldFilterOptionDisabled: false,
            filterOptions: dateFilterTypes,
            selectOptions: [],
            label: 'Date',
        },
    ],
};